<template>
<div>
    <section class="page-title contrato pf-title">
        <div class="center">
            <router-link to="/pessoajuridica" class="back-button fas fa-angle-left">
            </router-link>
            <p class="label-planos">Pessoa Jurídica</p>
            <h1 class="the-title">Contrato</h1>
        </div>
    </section>

    <section class="page-content center planos-form">
    <!-- <div class="plano-selecionado" style="background: #f1f1f1;"><span>{{this.planoSelecionado[2]}} {{this.planoSelecionado[1]}} - {{this.planoSelecionado[3]}} - R$ {{this.planoSelecionado.value}} (por pessoa) - {{this.planoSelecionado[4]}} - {{this.planoSelecionado[1]}}</span></div> -->
    <div class="plano-selecionado" style="background: #f1f1f1;"><span>{{this.planoSelecionado.name}} - {{this.planoSelecionado.registro}} - R$ {{this.planoSelecionado.value}} (por pet) - {{this.planoSelecionado.cobertura}}</span></div>
    <v-stepper v-model="e1">
    <v-stepper-header>
      <!-- <v-stepper-step :complete="e1 > 1" step="1">Primeiro Acesso</v-stepper-step>

      <v-divider></v-divider> -->

      <v-stepper-step :complete="e1 > 1" step="1" :editable="editPassos" >Dados da Empresa</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2" :editable="editPassos">Endereço</v-stepper-step>

      <v-divider></v-divider>
      
      <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Anexos</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 4" step="4" :editable="editPassos">Beneficiários</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="5" :editable="editPassos">Contratar o Plano</v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
<!-- PASSO 1 -->
      <v-stepper-content step="1">
    <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="empresa.fantasyName"
            v-validate="'required'"
            :error-messages="errors.collect('nomeFantazia')"
            data-vv-name="nomeFantazia"
            label="Nome Fantasia*"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="empresa.businessName"
            label="Razão Social*"
            box
            v-validate="'required'"
            :error-messages="errors.collect('razaoSocial')"
            data-vv-name="razaoSocial"
            ></v-text-field> 
            </v-flex>           
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            label="CNPJ*"
            v-model="empresa.cnpj"
            v-validate="'required'"
            :error-messages="errors.collect('cnpj')"
            data-vv-name="cnpj"
            return-masked-value mask="##.###.###/####-##"
            box
            ></v-text-field>
            </v-flex>  
            <v-flex xs12 sm12 lg8>      
            <v-text-field
            v-model="empresa.legalResponsible"
            label="Responsável Legal*"
            box
            v-validate="'required'"
            :error-messages="errors.collect('legalResponsible')"
            data-vv-name="legalResponsible"
            ></v-text-field> 
            </v-flex>                      
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="empresa.cellPhone"
            label="Telefone*"
            v-validate="'required'"
            :error-messages="errors.collect('telefone')"
            data-vv-name="telefone"
            return-masked-value mask="(##)#####-####"
            box
            ></v-text-field>
            </v-flex>            
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="empresa.legalResponsibleRg"
            label="RG (Responsável Legal)*"
            box
            v-validate="'required'"
            :error-messages="errors.collect('rg')"
            data-vv-name="rg"
            ></v-text-field>
            </v-flex> 
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="empresa.legalResponsibleCpf"
            label="CPF (Responsável Legal)*"
            v-validate="'required|cpf'"
            :error-messages="errors.collect('cpf')"
            return-masked-value mask="###.###.###-##"
            data-vv-name="cpf"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="empresa.infoEmailContact"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            label="E-mail para contato*"
            data-vv-name="email"
            box
            ></v-text-field>
            </v-flex> 
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="empresa.infoEmailInvoice"
            v-validate="'required|email'"
            :error-messages="errors.collect('emailFaturas')"
            label="E-mail para faturas*"
            data-vv-name="emailFaturas"
            box
            ></v-text-field>
            </v-flex>            
        </v-layout>
        </v-card>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#009b9b"
            @click="avancaPasso2()"
            >Continuar
        </v-btn>
        </v-container>
      </v-stepper-content>
    <!-- FIM DO PASSO 1 -->

    <!-- PASSO 2 --> 
      <v-stepper-content step="2">
        <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="empresa.cep"
            label="CEP*"
            return-masked-value mask="#####-###"
            v-validate="'required'"
            :error-messages="errors.collect('cep')"
            data-vv-name="cep"
            :keyup="retornoViaCEP()"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg9>      
            <v-text-field
            v-model="empresa.address"
            label="Rua*"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="empresa.addressNumber"
            label="Número*"
            type="number"
            v-validate="'required'"
            :error-messages="errors.collect('numero')"
            data-vv-name="numero"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="bairro"
            label="Bairro*"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="cidade"
            label="Cidade*"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="estado"
            label="Estado*"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg12>
            <v-text-field
            v-model="empresa.addressComplement"
            label="Complemento"
            box
            ></v-text-field>
            </v-flex>
        </v-layout>
        </v-card>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#009b9b"
            @click="avancaPasso3()"
            >Continuar
        </v-btn>
        </v-container>
      </v-stepper-content>

      <!-- FIM DO PASSO 2 -->

 
 
 <!-- PASSO 3 --> 
      <v-stepper-content step="3">
        <v-container grid-list-md >
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap >

        <!-- RG1 -->
        <v-flex xs12 sm12 lg4>                
        <file-upload
        class="btn btn-primary"
          input-id="file1"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesRg1"
          @input-filter="inputFilter"
          @input-file="inputFileRg1"
          ref="upload1">
          <p class="form-titulo" style="font-size: 20px">RG Repres. Legal (FRENTE)*</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#78909C"
            >Selecionar arquivo
        </v-btn> 
        <p id="rg1" value="" hidden></p>     
        <p v-if="filesRg1 == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p style="color:#9E9D24" v-for="(file) in filesRg1" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>              
        </v-flex>

       <!-- RG2 --> 
      <v-flex xs12 sm12 lg4>    
        <file-upload
        class="btn btn-primary"
          input-id="file2"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesRg2"
          @input-filter="inputFilter"
          @input-file="inputFileRg2"
          ref="upload2">
          <p class="form-titulo" style="font-size: 20px">RG Repres. Legal (VERSO)*</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#78909C"
            >Selecionar arquivo
        </v-btn>  
        <p id="rg2" value="" hidden></p>    
        <p v-if="filesRg2 == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p style="color:#9E9D24" v-for="(file) in filesRg2" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

      <!-- CPF --> 
      <v-flex xs12 sm12 lg4>    
        <file-upload
        class="btn btn-primary"
          input-id="file3"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesCPF"
          @input-filter="inputFilter"
          @input-file="inputFileCPF"
          ref="upload3">
          <p class="form-titulo" style="font-size: 20px">CPF Repres. Legal*</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#78909C"
            >Selecionar arquivo
        </v-btn>  
        <p id="cpf" value="" hidden></p>    
        <p v-if="filesCPF == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p style="color:#9E9D24" v-for="(file) in filesCPF" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

      <!-- CNPJ --> 
      <v-flex xs12 sm12 lg4>    
        <file-upload
        class="btn btn-primary"
          input-id="file4"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesCNPJ"
          @input-filter="inputFilter"
          @input-file="inputFileCNPJ"
          ref="upload4">
          <p class="form-titulo" style="font-size: 20px">CNPJ*</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#78909C"
            >Selecionar arquivo
        </v-btn>  
        <p id="cnpj" value="" hidden></p>    
        <p v-if="filesCNPJ == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p style="color:#9E9D24" v-for="(file) in filesCNPJ" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

      <!-- ENDEREÇO --> 
      <v-flex xs12 sm12 lg4>    
        <file-upload
        class="btn btn-primary"
          input-id="file5"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesAddress"
          @input-filter="inputFilter"
          @input-file="inputFileAddress"
          ref="upload5">
          <p class="form-titulo" style="font-size: 20px">Comp. de Endereço*</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#78909C"
            >Selecionar arquivo
        </v-btn>     
        <p id="address" value="" hidden></p> 
        <p v-if="filesAddress == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p style="color:#9E9D24" v-for="(file) in filesAddress" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

      <!-- ATOS CONSTITUTIVOS --> 
      <v-flex xs12 sm12 lg4>    
        <file-upload
        class="btn btn-primary"
          input-id="file6"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesphysicalCOntract1"
          @input-filter="inputFilter"
          @input-file="inputFilephysicalContract1"
          ref="upload6">
          <p class="form-titulo" style="font-size: 20px">Ato Constitutivo*</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#78909C"
            >Selecionar arquivo
        </v-btn>  
        <p id="physicalContract1" value="" hidden></p>    
        <p v-if="filesphysicalCOntract1 == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p style="color:#9E9D24" v-for="(file) in filesphysicalCOntract1" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>        

      <!-- OUTROS --> 
      <v-flex xs12 sm12 lg4>    
        <file-upload
        class="btn btn-primary"
          input-id="file7"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesOutros"
          @input-filter="inputFilter"
          @input-file="inputFileOutros"
          ref="upload7">
          <p class="form-titulo" style="font-size: 20px">Outros*</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#78909C"
            >Selecionar arquivo
        </v-btn>  
        <p id="outros" value="" hidden></p>    
        <p v-if="filesOutros == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p style="color:#9E9D24" v-for="(file) in filesOutros" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

        </v-layout>
        </v-card>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#009b9b"
            @click="avancaPasso4()"
            >Continuar
        </v-btn>
        </v-container>
      </v-stepper-content>

      <!-- FIM DO PASSO 3 -->
 
 
 <!-- PASSO 4 -->
  <v-stepper-content step="4">     
        <v-container grid-list >
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap>
        <v-flex xs12 sm12 lg10>
          <p class="form-titulo" style="margin-top: 10px;">Adicionar beneficiários</p>
        </v-flex>
        <v-flex xs12 sm12 lg2 style="text-align: end;">
        <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="dialogTitular=true"><v-icon left dark>add_circle</v-icon>TITULAR</v-btn>
        </v-flex>
        <v-flex xs12 sm12 lg12 v-if="holderList!=''">
          <v-data-table                       
            :headers="headersFunc" 
            :items="holderList"    
            rows-per-page-text="Linhas por página"              
            :pagination.sync="pagination"
            class="elevation-2">     
            <v-progress-linear slot="progress" color="teal" indeterminate></v-progress-linear>         
              <template slot="items" slot-scope="props">   
                <tr>
                <td class="text-xs-left" style="color:#0288D1; font-weight: bold;">TITULAR</td>              
                <td class="text-xs-left">{{ props.item.firstName }}</td>
                <td class="text-xs-left">{{ props.item.cpf }}</td>      
                <td class="justify-right layout px-0">                                   
                  <v-tooltip bottom>
                    <template slot="activator">
                      <v-btn icon class="mx-0" @click="editItemTit(props.item)">
                        <v-icon color="teal">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template slot="activator">
                      <v-btn icon class="mx-0" @click="deleteItemTit(props.item)">
                        <v-icon color="red">delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="props.item.isHolder">
                    <template slot="activator">
                      <v-btn icon class="mx-0" @click="openDialogDep(props.item)">
                        <v-icon color="#1565C0">group_add</v-icon>
                      </v-btn>
                    </template>
                    <span>Incluir dependente</span>
                  </v-tooltip>                  
                </td>
                </tr>
                <tr v-for="dependente in props.item.dependents" :key="dependente.firstName">             
                <td class="text-xs-left" style="color:#546E7A; font-weight: bold;padding-left: 40px;">DEPENDENTE</td>
                <td class="text-xs-left">{{ dependente.firstName }}</td>
                <td class="text-xs-left">{{ dependente.cpf }}</td>      
                <td class="justify-right layout px-0">                                   
                  <v-tooltip bottom>
                    <template slot="activator">
                      <v-btn icon class="mx-0" @click="editItemDep(dependente)">
                        <v-icon color="teal">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template slot="activator">
                      <v-btn icon class="mx-0" @click="deleteItemDep(dependente)">
                        <v-icon color="red">delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>                  
                </td>
                </tr>
              </template>                   
            </v-data-table>              
        </v-flex>

        <v-layout row wrap v-if="holderList!=''">
        <v-flex xs12 sm12 lg12 > 
          <br>
          <p class="form-titulo">Quantidade de Beneficiários:</p>
        </v-flex>

        <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiários Titular</p>
              <span class="subtotal">{{empresa.amountHolder}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiários Dependente</p>
              <span class="subtotal">{{empresa.amountDependent}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo">
                  <p style="margin-bottom: 0px;">Total de Beneficiários</p>
                  <span class="total">{{qtdUsuarios}}</span>                  
          </div>
          </v-flex>
            
          <br>
          <v-flex xs12 sm12 lg12>      
            <p class="form-titulo" >Resumo da proposta</p>
          </v-flex>
          <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiário Titular</p>
              <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Dependente(s)</p>
              <span class="subtotal">R$ {{valorDependentes.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                  <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                  
          </div>
          <div class="resumo" v-else>
              <p style="margin-bottom: 0px;">Total a pagar</p>
              <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
          </div>   
          <br>
          </v-flex> 
          <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
            <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pet (Apenas na primeira mensalidade)</p> 
          </v-flex>
          </v-layout>   
        </v-layout>         
        </v-card>
        <v-flex md12 xs12 sm12 lg2>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#009b9b"
            @click="avancaPasso5()"
            >Continuar
        </v-btn>
      </v-flex>
      </v-container>            
      </v-stepper-content>

      <!-- FIM DO PASSO 4 -->

      <!-- PASSO 5 -->

      <v-stepper-content step="5">
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-container grid-list-md>
          <v-layout row wrap>
          <v-flex xs12 sm12 lg12 v-if="exibeCorretor">      
            <p class="form-titulo" >Corretor</p>          
          <v-flex xs12 sm12 lg12>            
            <v-radio-group v-model="temVendedor" row :disabled="linkVendedor">
                <strong style="font-weight: bold;">Você foi auxiliado por algum corretor? &nbsp;&nbsp;</strong>
                <v-radio color="#446fb5" label="Sim" :value="true"></v-radio>
                <v-radio color="#446fb5" label="Não" :value="false"></v-radio>
            </v-radio-group>
            </v-flex>
          <v-flex xs12 sm12 lg4 v-if="!linkVendedor">
                <v-text-field                
                v-if="temVendedor ? true : cpfVendedor = ''"
                v-model="cpfVendedor"
                label="CPF"                
                box
                mask="###.###.###-##"
                :keyup="consultaVendedor()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg8>      
            <v-text-field
            v-if="temVendedor ? temVendedor == true : nomeVendedor = ''"
            v-model="nomeVendedor"
            label="Corretor"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <hr>
            <br>
            </v-flex>
        <v-flex xs12 sm12 lg12>      
            <p class="form-titulo" >Contrato</p>
          </v-flex>
          <v-flex xs12 sm12 md12 lg8>
            <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
          </v-flex>
          <v-flex xs12 sm12 md12 lg4>     

          <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
            </v-list-tile>
            </div>
          <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" :href="planoSelecionado.urlMinutaContrato" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
            </v-list-tile>
            </div>

            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" :href="planoSelecionado.urlMinutaAditivo" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
            </v-list-tile>
            </div>


            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
            @click="pdfSelecionado = planoSelecionado.urlCobertura" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
            @click="pdfSelecionado = planoSelecionado.urlCobertura" :href="planoSelecionado.urlCobertura" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
            </v-list-tile>
            </div>


            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
            @click="pdfSelecionado = planoSelecionado.urlManual" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Manual de Orientação</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
            @click="pdfSelecionado = planoSelecionado.urlManual" :href="planoSelecionado.urlManual" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Manual de Orientação</v-list-tile-title>
            </v-list-tile>
            </div>            


            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
            @click="pdfSelecionado = planoSelecionado.urlGuia" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
            @click="pdfSelecionado = planoSelecionado.urlGuia" :href="planoSelecionado.urlGuia" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
            </v-list-tile>
            </div>

          </v-flex>
          <v-flex xs12 sm3 md12 lg12>
            <v-checkbox
            v-model="contrataccept"
              color="#009B99"
          >
          <span slot="label">Li e concordo com os termos do contrato<!-- <a @click.stop :href="this.planoSelecionado[8]"
            target="popup" 
            :onclick="`window.open(${this.planoSelecionado[8]},popup,width=800,height=600); return false;`">termos do contrato</a> --></span>
          </v-checkbox>
          </v-flex>
          <hr>
          <br>
          <v-flex xs12 sm12 lg12>      
            <p class="form-titulo" >Dia de Vencimento</p>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <v-radio-group v-model="empresa.dueDate" row>
            <v-radio color="#009B99" label="5" value="5"></v-radio>
            <v-radio color="#009B99" label="10" value="10"></v-radio>
            <v-radio color="#009B99" label="15" value="15"></v-radio>
            <v-radio color="#009B99" label="20" value="20"></v-radio>
            <v-radio color="#009B99" label="25" value="25"></v-radio>
            <v-radio color="#009B99" label="30" value="30"></v-radio>
          </v-radio-group>
          </v-flex>
          <hr>
          <br>
          <v-flex xs12 sm12 lg12>      
            <p class="form-titulo" >Resumo da proposta</p>
          </v-flex>
          <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiário Titular</p>
              <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Dependente(s)</p>
              <span class="subtotal">R$ {{valorDependentes.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                  <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                    
          </div>
          <div class="resumo" v-else>
              <p style="margin-bottom: 0px;">Total a pagar</p>
              <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
          </div>          
          <br>
          </v-flex> 
          <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
            <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pet (Apenas na primeira mensalidade)</p> 
          </v-flex>                          
        </v-layout>        
        </v-container>
      <v-flex md12 xs12 sm12 lg12>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#009b9b"
            @click="enviarProposta()"          
            >Enviar Proposta
        </v-btn>
      </v-flex>         
        </v-card>
      </v-stepper-content>      
    </v-stepper-items>
  </v-stepper>

  <!-- DIALOG CONCLUSAO -->
  <v-dialog v-model="dialogLoading" max-width="600px" max-height="300px" persistent> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="subtotal" v-if="loading">{{msgLoading}}</span>
              <span class="total" v-else>Parabéns</span>              
              </v-card-title>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <v-progress-circular
                :size="50"
                color="#009B99"
                indeterminate
                v-if="loading"
              ></v-progress-circular>
              <p class="resumo" style="text-align: center;" v-else>Um e-mail de confirmação foi enviado para <span style="font-weight: 700;">{{email}}</span>. Por favor, verifique seu e-email para confirmar a proposta.</p>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" v-if="!loading" style="border-radius: 8px; width: 130px;" dark @click="confirmaContrato()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG CONCLUSAO -->

    <!-- DIALOG TITULAR -->
    <v-dialog v-model="dialogTitular" max-width="850px" persistent>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitleTitular }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-model="funcionario.firstName" label="Nome Completo*" box v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex" :error-messages="errors.collect('firstName')" data-vv-name="firstName"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field v-model="funcionario.email" v-validate="'required|email'" :error-messages="errors.collect('email')" label="E-mail*" data-vv-name="email" box></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm12 lg4>
                      <v-select v-model="funcionario.gender" label="Sexo*" v-validate="'required'" :error-messages="errors.collect('gender')" data-vv-name="gender" :items="generos" item-text="text" item-value="value" box></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="dataNascFunc" label="Data de Nascimento*" v-validate="'required|date_format:dd/MM/yyyy'" :error-messages="errors.collect('dateOfBirth')" return-masked-value mask="##/##/####" data-vv-name="dateOfBirth" box></v-text-field>
                    </v-flex>     
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="funcionario.cpf" label="CPF*" v-validate="'required|cpf'" :error-messages="errors.collect('cpfDep')" return-masked-value mask="###.###.###-##" data-vv-name="cpfDep" box></v-text-field>
                    </v-flex>                                                                          
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="funcionario.rg" label="RG*" v-validate="'required'" :error-messages="errors.collect('rg')" data-vv-name="rg" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="funcionario.rgEmitter" label="Órgão Expedidor*" v-validate="'required'" :error-messages="errors.collect('rgEmissor')" data-vv-name="rgEmissor" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="funcionario.susNumber" label="CNS (Cartão do SUS)" v-validate="'cns'" :error-messages="errors.collect('cns')" data-vv-name="cns" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="funcionario.cellPhone" label="Telefone*" return-masked-value mask="(##)#####-####" v-validate="'required'" :error-messages="errors.collect('Celular')" data-vv-name="Celular" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-model="funcionario.motherName" label="Nome da Mãe*" v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex" :error-messages="errors.collect('motherName')" data-vv-name="motherName" box></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="adicionarTit">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    <!-- DIALOG TITULAR -->

    <!-- DIALOG DELETE TITULAR -->
    <v-dialog v-model="dialogDelTitular" max-width="600px" persistent>
            <v-card>
              <v-card-title>
                <span class="headline">Excluir Titular</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 lg12>
                      <p>Confirma a exclusão do titular <span style="font-weight: bold;">{{funcionario.firstName}}</span> e seus dependentes?</p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>                
                <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="excluirTit">Excluir</v-btn>
                <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    <!-- DIALOG DELETE TITULAR -->

    <!-- DIALOG DELETE DEPENDENTE -->
    <v-dialog v-model="dialogDelDep" max-width="600px" persistent>
            <v-card>
              <v-card-title>
                <span class="headline">Excluir Dependente</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 lg12>
                      <p>Confirma a exclusão do dependente <span style="font-weight: bold;">{{dependente.firstName}}</span>?</p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>                
                <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="excluirDep">Excluir</v-btn>
                <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    <!-- DIALOG DELETE DEPENDENTE -->

    <!-- DIALOG DEPENDENTE -->
    <v-dialog v-model="dialogDep" max-width="850px" persistent>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 lg4>
                      <v-select v-model="dependente.parentage" label="Parentesco*" v-validate="'required'" :error-messages="errors.collect('parentage')" data-vv-name="parentage" :items="parentesco" item-text="text" item-value="value" box></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field v-model="dependente.firstName" label="Nome Completo*" box v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex" :error-messages="errors.collect('firstName')" data-vv-name="firstName"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field v-model="dependente.email" v-validate="'required|email'" :error-messages="errors.collect('email')" label="E-mail*" data-vv-name="email" box></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm12 lg4>
                      <v-select v-model="dependente.gender" label="Sexo*" v-validate="'required'" :error-messages="errors.collect('gender')" data-vv-name="gender" :items="generos" item-text="text" item-value="value" box></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="dataNascDependent" label="Data de Nascimento*" v-validate="'required|date_format:dd/MM/yyyy'" :error-messages="errors.collect('dateOfBirthDep')" return-masked-value mask="##/##/####" data-vv-name="dateOfBirthDep" box></v-text-field>
                    </v-flex>     
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="dependente.cpf" label="CPF*" v-validate="'required|cpf'" :error-messages="errors.collect('cpfDep')" return-masked-value mask="###.###.###-##" data-vv-name="cpfDep" box></v-text-field>
                    </v-flex>                                                                          
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="dependente.rg" label="RG*" v-validate="'required'" :error-messages="errors.collect('rg')" data-vv-name="rg" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="dependente.rgEmitter" label="Órgão Expedidor*" v-validate="'required'" :error-messages="errors.collect('rgEmissor')" data-vv-name="rgEmissor" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="dependente.susNumber" label="CNS (Cartão do SUS)" v-validate="'cns'" :error-messages="errors.collect('cns')" data-vv-name="cns" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field v-model="dependente.cellPhone" label="Telefone*" return-masked-value mask="(##)#####-####" v-validate="'required'" :error-messages="errors.collect('Celular')" data-vv-name="Celular" box></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-model="dependente.motherName" label="Nome da Mãe*" v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex" :error-messages="errors.collect('motherName')" data-vv-name="motherName" box></v-text-field>
                    </v-flex>                                                            
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="adicionarDep">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    <!-- DIALOG DEPENDENTE -->
  <loading :active.sync="isLoading" :can-cancel="true" color="#009b9b" :is-full-page="fullPage"></loading>
    </section>
    <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
import CpfValidate from '../components/validators/rules/cpf'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {

components: {Snackbar, FileUpload, Loading},
    data(){
        return {
            fullPage: true,
            isLoading: false,
            dataNascFunc: '',
            dataNascDependent: '',
            validarDataNascFunc: false,
            validarDataNascDep: false,
            dialogDep: false,
            dialogDelTitular: false,
            dialogDelDep: false,
            dialogTitular: false,
            exibeCorretor: true,
            qtdUsuarios: 0,
            pdfSelecionado: '',
            files: [],
            erros: [],
            search: '',
            planilhaValidada: false,
            pagination: {'sortBy': 'name', 'rowsPerPage': 10},
            pagCartao: false,
            msgLoading: '',
            loading: false,
            financialManagUF: '',
            salesOrale: '5cc0a27ee2cead066040bfc9',
            brokerOrale: '5cc0a118e2cead066040bfc6',
            contrataccept: false,
            temVendedor: false,
            linkVendedor: false,
            nomeVendedor: '',
            vendedorLink: [],
            vendedor: [],
            salesman: [],
            cpfVendedor: '',           
            editPassos: false,
            editedIndex: '',
            editedIndexTitular: '',
            valorDependentes: '0,00',
            valorTotalProposta: '0,00',
            valorTitular: '0,00',
            dialogValidacao: false,
            dialogLoading: false,         
            e1: 0,
            bairro: '',
            cidade: '',
            estado: '',
            estados: [],
            Anexos: {
              id: '',
              imagesDocs: {
                usersTableExt: 'xlsx',
                usersTable: '',
                rg: '',
                rg2: '',
                cpf: '',
                cnpj: '',
                address: '',
                physicalContract1: '',
                others: '',
              }
            },
            filesRg1: [],
            filesRg2: [],
            filesCPF: [],
            filesAddress: [],
            filesOutros: [],
            filesCNPJ: [],
            filesphysicalCOntract1: [],
            vencimeto: ['5','10','15','20','25','30'],
            generos: [
            { value: 1, text: "Masculino" },
            { value: 0, text: "Feminino" } ],
            estadoscivil: [
            { value: "SOLTEIRO", text: "Solteiro(a)" },
            { value: "CASADO", text: "Casado(a)" },
            { value: "VIÚVO", text: "Viúvo(a)" },
            { value: "DIVORCIADO", text: "Divorciado(a)" } ],
            planoSelecionado: {
              id: '',
              name: '',
              value: '0,00',
              oldValue: '0,00',
              taxaImplantacao: '0,00',
              urlMinutaContrato: '',
              familyTable: {
                value2: '',
                value3: '',
                value4: '',
                value5: '',
                value6: ''
              }
            },
            headersFunc: [
            {
                text: 'Tipo',
                align: 'left',
                value: 'isHolder'
            },
            { text: 'Nome',align: 'left', value: 'firstName' },
            { text: 'CPF',align: 'left', value: 'cpf' },
            { text: 'Ações', align: 'left', value: 'name', sortable: false }
                ],
            email: '',
            empresaId: '',
            empresa:{
              plansId: '',
              dueDate: '',
              confirmPassword: '',
              password: '',
              cnpj: '',
              openingDate: '',
              fantasyName: '',
              businessName: '',
              cep: '',
              state: 0,
              addressType: 0,
              address: '',
              addressNumber: '',
              city: '',
              district: '',
              addressComplement: '',
              homePhone: '',
              cellPhone: '',
              cellPhone2: '',
              legalResponsible: '',
              legalResponsibleRg: '',
              legalResponsibleCpf: '',
              legalResponsibleEmail: '',
              infoWorkerName: '',
              infoEmailContact: '',
              infoHomePhone: '',
              infoCellPhone: '',
              infoEmailInvoice: '',
              infoPersonInCharge: '',
              infoPersonInChargePhone: '',
              effectiveDate: '',
              effectiveDateMonth: '',
              effectiveDateYear: '',
              monthlyExpiration: '',
              cuttingDay: '',
              typeOfContract: '',
              amountUsers: '',
              status: 'AGUARDANDO PAGAMENTO',
              analyzing: false,
              afterSales: false,
              costCenterS4: 0,
              carenciaCoberturaS4: 1,
              valuePlanHolder: '',
              valuePlanDependent: '',
              responsibility: '',
              valuePlanOrto: '',
              valuePlanDivergent: false,
              includesOrto: false,
              amountHolder: 0,
              amountDependent: 0,
              amountOrto: 0,
              salesmanIPConfirm: '',
              companyIPConfirm: '',
              chanelConfirm : 'EMAIL',
              salesmanId: '',
              brokerId: '',
              cancellationId: '',
              pendencyId: '',
              completeRegistration: false,
            },    
            funcList: [],
            holderList: [],
            editedFunc:'',
            funcionario:
            {
                firstName: "",
                cpf: "",
                email: "",
                cellPhone: "",
                rg: "",
                rgEmitter: "",
                dateOfBirth: "",
                motherName: "",
                gender: "",
                plansId: "",
                susNumber: "",
                isHolder: true,
                companyId: "ID_DA_COMPANY",
                dependents: [],
                tempId: '' 
            },
            defaltfuncionario:
                {
                firstName: "",
                cpf: "",
                email: "",
                cellPhone: "",
                rg: "",
                rgEmitter: "",
                dateOfBirth: "",
                motherName: "",
                gender: "",
                plansId: "",
                susNumber: "",
                isHolder: true,
                companyId: "ID_DA_COMPANY",
                dependents: [],
                tempId: '' 
            },  
            dependente:
            {
                  firstName: "",
                  cpf: "",
                  email: "",
                  cellPhone: "",
                  rg: "",
                  rgEmitter: "",
                  dateOfBirth: "",
                  motherName: "",
                  gender: "",
                  plansId: "",
                  susNumber: "",
                  isHolder: false,
                  companyId: "ID_DA_COMPANY",
                  holderId: "ID_DO_TITULAR",   
                  tempId: '',
                  parentage: '',                            
            },
            defaultdependente:
            {
                  firstName: "",
                  cpf: "",
                  email: "",
                  cellPhone: "",
                  rg: "",
                  rgEmitter: "",
                  dateOfBirth: "",
                  motherName: "",
                  gender: "",
                  plansId: "",
                  susNumber: "",
                  isHolder: false,
                  companyId: "ID_DA_COMPANY",
                  holderId: "ID_DO_TITULAR", 
                  tempId: '',
                  parentage: ''                              
            },                
            Sales: {
              status: 'PAGAMENTO PENDENTE',
              fMIPConfirm: '',
              fMConfirm: '',
              salesmanIPConfirm: '',
              financialManagerId: '',
              salesmanId: '',
              brokerId: '',
              salesmanConfirm: '',
              paymentId: ''
            },

            precoPlano: 
            {
                valorTitular: "",
                valorDependente: "",
                valorAgregado: "",
                companyId: "ID_DA_COMPANY",
                plansId: "ID_DO_PLANO_1",
              },

            parentesco: [{
                value: 'CÔNJUGE',
                text: "CÔNJUGE"
              },
              {
                value: 'FILHO',
                text: "FILHO(A)"
              },
              {
                value: 'PAI/MÃE',
                text: "PAI/MÃE"
              },
              {
                value: 'AGREGADO',
                text: "AGREGADO"
              },
              {
                value: 'AGREGADO',
                text: "IRMÃO(A)"
              },
              {
                value: 'AGREGADO',
                text: "SOBRINHO(A)"
              },
              {
                value: 'AGREGADO',
                text: "NETO(A)"
              }
            ],
                  
            steppers: {
              default: 0,
              type: Number
            },
            idUser: '',
            dictionary: {          
                custom: {
                email: {
                    required: () => 'Informe o Email',
                    email: () => 'Informe um Email válido'
                },
                emailFaturas: {
                  required: () => 'Informe o Email',
                  email: () => 'Informe um Email válido'
                },
                telefone: {
                    required: () => 'Informe o Telefone'
                },
                cep:{
                   required: () => 'Informe o CEP'
                },
                numero: {
                  required: () => 'Informe o Número, caso não tenha informe 0'
                },
                rg: {
                  required: () => 'Informe o RG'
                },
                dateOfBirth: {
                  required: () => 'Informe a Data de Nascimento',
                  date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
                },
                dateOfBirthDep: {
                  required: () => 'Informe a Data de Nascimento',
                  date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
                },
                cnpj: {
                  required: () => 'Informe o CNPJ'
                },
                razaoSocial: {
                  required: () => 'Informe a Razão Social'
                },
                nomeFantazia: {
                  required: () => 'Informe o Nome Fantasia'
                },  
                legalResponsible: {
                  required: () => 'Informe o Responsável Legal'
                },
                amountHolder: {
                  required: () => 'Informe a quantidade de Titulares'
                },
                amountDependent: {
                  required: () => 'Informe a quantidade de Dependentes'
                },
                rgEmissor: {
                  required: () => 'Informe o Órgão Expedidor do RG'
                },
                motherName: {
                  required: () => 'Informe o nome da Mãe',
                  regex: () => 'Informe nome e sobrenome'
                }, 
                firstName: {
                  required: () => 'Informe nome e sobrenome',
                  regex: () => 'Informe nome e sobrenome'
                }, 
                gender: {
                  required: () => 'Informe o Sexo'
                },  
                parentage: {
                  required: () => 'Informe o Parentesco'
                },     
            }
            } 

        }
    },
     mounted : function(){

       /* this.funcionario.tempId = Math.floor(10 + Math.random() * 10)
       this.funcList.push(this.funcionario) */
       if(localStorage.getItem('planoSelecionado') != null)
       {
          let planoLocal = JSON.parse(localStorage.getItem('planoSelecionado'))
          if (planoLocal && planoLocal.id) {
            axios.get(`${baseApiUrl}Plans/buscarPublicoPorId?id=${planoLocal.id}`).then(res => {
              if (res.data != null) {
                this.planoSelecionado = res.data
                this.pdfSelecionado = this.planoSelecionado.urlMinutaContrato
              }
            })
          }
       }
       else
        this.pegaParametrosUrl()
          
        this.carregaDados()
        this.$validator.localize('pt', this.dictionary)
        this.$store.dispatch('Logar')     
        
        if(sessionStorage.getItem('Vendedor') != null){
            this.vendedorLink = JSON.parse(sessionStorage.getItem('Vendedor'))
            this.temVendedor = true
            this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite
        }
        //this.valorTotalProposta = this.planoSelecionado.value /* + parseFloat(this.valorTaxaImplantacao) */ 
    },
    watch: {
    dialog(val) {
    val || this.close()
      }
    },
    computed: {       
        formTitle() {
          return this.editedIndex === '' ? 'Incluir Dependente' : 'Editar Dependente'
        },
        formTitleTitular() {
          return this.editedIndexTitular === '' ? 'Incluir Titular' : 'Editar Titular'
        }
    },
    methods: {

      async adicionarDep(){
        await this.$validator.validate('dateOfBirthDep').then(valid => {
          if (!valid)
            this.validarDataNascDep = false
          else
            this.validarDataNascDep = true
        });

      if(this.dependente.tempId == '')
        {
          if(!CpfValidate(this.dependente.cpf) || this.dependente.firstName == '' || this.dependente.cpf == '' || this.dependente.email == '' || this.dependente.cellPhone == '' || this.dependente.rg == '' || this.dependente.rgEmitter == '' || this.dependente.motherName == '' || this.dependente.gender == null || this.dataNascDependent == '' || this.dependente.parentage == '' || !this.validarDataNascDep)
          {
              this.$validator.validateAll()
          }
          else
          {
          this.dependente.dateOfBirth = this.formatDate(this.dataNascDependent)
          this.dependente.tempId = Math.floor(100 + Math.random() * 100)  
          this.dependente.plansId = this.planoSelecionado.id        
          this.editedFunc.dependents.push(this.dependente)
          this.dependente = Object.assign({}, this.defaultdependente)
          this.empresa.amountDependent = this.empresa.amountDependent + 1
          this.qtdUsuarios = this.qtdUsuarios + 1
          this.calculaPlano(this.planoSelecionado)
          this.dialogDep = false
          this.$validator.reset()
          }
        }
        else
        {
            this.editedFunc.dependents.forEach(item => {
            if(item.tempId == this.dependente.tempId)
            {
               if(!CpfValidate(this.dependente.cpf) || this.dependente.firstName == '' || this.dependente.cpf == '' || this.dependente.email == '' || this.dependente.cellPhone == '' || this.dependente.rg == '' || this.dependente.rgEmitter == '' || this.dependente.motherName == '' || this.dependente.gender == null || this.dataNascDependent == '' || this.dependente.parentage == '' || !this.validarDataNascDep)
            {
                this.$validator.validateAll()
            }
            else
            {
                var idx = this.editedFunc.dependents.indexOf(item);
                this.dependente.dateOfBirth = this.formatDate(this.dataNascDependent)
                Object.assign(this.editedFunc.dependents[idx], this.dependente)                
                this.dependente = Object.assign({}, this.defaultdependente)
                this.close()
                this.$validator.reset()
              }
            }
          });
        }
      },
      
      openDialogDep(item){
        this.dialogDep = true
        this.editedFunc = ''
        this.editedFunc = item
      },
      async adicionarTit(){     
        await this.$validator.validate('dateOfBirth').then(valid => {
          if (!valid)
            this.validarDataNascFunc = false
          else
            this.validarDataNascFunc = true
        });

        if(this.funcionario.tempId == '')
        {
          if(!CpfValidate(this.funcionario.cpf) || this.funcionario.firstName == '' || this.funcionario.cpf == '' || this.funcionario.email == '' || this.funcionario.cellPhone == '' || this.funcionario.rg == '' || this.funcionario.rgEmitter == '' || this.funcionario.motherName == '' || this.funcionario.gender == null || this.dataNascFunc == '' || !this.validarDataNascFunc)
          {
              this.$validator.validateAll()
          }
          else
          {
          this.funcionario.dependents = []
          this.funcionario.dateOfBirth = this.formatDate(this.dataNascFunc)
          this.funcionario.tempId = Math.floor(100 + Math.random() * 100)    
          this.funcionario.plansId = this.planoSelecionado.id      
          this.holderList.push(this.funcionario)
          this.funcionario = Object.assign({}, this.defaltfuncionario)
          this.empresa.amountHolder = this.empresa.amountHolder + 1
          this.qtdUsuarios = this.qtdUsuarios + 1
          this.calculaPlano(this.planoSelecionado)
          this.close()
          //this.$validator.reset()
          }
        }
        else
        {
            this.holderList.forEach(item => {
            if(item.tempId == this.funcionario.tempId)
            {
              if(!CpfValidate(this.funcionario.cpf) || this.funcionario.firstName == '' || this.funcionario.cpf == '' || this.funcionario.email == '' || this.funcionario.cellPhone == '' || this.funcionario.rg == '' || this.funcionario.rgEmitter == '' || this.funcionario.motherName == '' || this.funcionario.gender == null || this.dataNascFunc == '' || !this.validarDataNascFunc)
              {
                  this.$validator.validateAll()
              }
              else
              {
                var idx = this.holderList.indexOf(item);
                this.funcionario.dateOfBirth = this.formatDate(this.dataNascFunc)
                Object.assign(this.holderList[idx], this.funcionario)                
                this.funcionario = Object.assign({}, this.defaltfuncionario)
                this.close()
                this.$validator.reset()  
              }             
            }
          });
        }
      },
        editItemTit(item) {       
          this.funcionario = Object.assign({}, item)
          this.dataNascFunc = this.formatDateBrz(item.dateOfBirth)
          this.dialogTitular = true          

        },
        deleteItemTit(item)
        {
          this.funcionario = Object.assign({}, item)
          this.dialogDelTitular = true
        },
        excluirTit(){
          this.holderList.forEach(item => {
            if(item.tempId == this.funcionario.tempId)
            {
              var index = this.holderList.indexOf(item);
              this.holderList.splice(index, 1)
              this.funcionario = Object.assign({}, this.defaltfuncionario)
              this.empresa.amountHolder = this.empresa.amountHolder - 1
              this.qtdUsuarios = this.qtdUsuarios - 1
              this.calculaPlano(this.planoSelecionado)
              this.close()
              this.$validator.reset()
            }
          });
        },
        editItemDep(item) {       
          this.dependente = Object.assign({}, item)
          this.dataNascDependent = this.formatDateBrz(item.dateOfBirth)
          this.dialogDep = true          

        },
        deleteItemDep(item)
        {
          this.dependente = Object.assign({}, item)
          this.dialogDelDep = true
        },
        excluirDep(){
           this.editedFunc.dependents.forEach(item => {
            if(item.tempId == this.dependente.tempId)
            {
              var index = this.editedFunc.dependents.indexOf(item);
              this.editedFunc.dependents.splice(index, 1)
              this.dependente = Object.assign({}, this.defaultdependente)
              this.empresa.amountDependent = this.empresa.amountDependent - 1
              this.qtdUsuarios = this.qtdUsuarios - 1
              this.calculaPlano(this.planoSelecionado)
              this.dialogDelDep = false
              this.$validator.reset()
            }
          });
        },
        async carregaDados(){
            await axios.get(`${baseApiUrl}UFs/listaPublica`).then(res => {        
            if(res.data != null){      
            this.estados = res.data 
            }              	
          })
        },
        async avancaPasso2(){
            if(this.empresa.fantasyName == '' || this.empresa.cnpj == '' || this.empresa.legalResponsible == '' || this.empresa.infoEmailContact == '' || this.empresa.businessName == '' || this.empresa.legalResponsibleRg == '' || this.empresa.legalResponsibleCpf == '' || this.empresa.infoEmailInvoice == '' || this.empresa.cellPhone == '')
            this.$validator.validateAll()
            else{
              this.$validator.reset()
              this.e1 = 2
            }
        },



        async avancaPasso3(){
            if(this.empresa.cep == '' || this.empresa.addressNumber == null)
            this.$validator.validateAll()
            else{
              this.$validator.reset() 
              this.e1 = 3
            }
        },

        async avancaPasso4(){
          this.Anexos.imagesDocs.rg = document.getElementById("rg1").value
          this.Anexos.imagesDocs.rg2 = document.getElementById("rg2").value
          this.Anexos.imagesDocs.cpf = document.getElementById("cpf").value
          this.Anexos.imagesDocs.address = document.getElementById("address").value
          this.Anexos.imagesDocs.others = document.getElementById("outros").value
          this.Anexos.imagesDocs.cnpj = document.getElementById("cnpj").value
          this.Anexos.imagesDocs.physicalContract1 = document.getElementById("physicalContract1").value
          
            if(this.Anexos.imagesDocs.rg == undefined || this.Anexos.imagesDocs.rg2 == undefined || this.Anexos.imagesDocs.cpf == undefined || this.Anexos.imagesDocs.address == undefined || this.Anexos.imagesDocs.others == undefined || this.Anexos.imagesDocs.cnpj == undefined || this.Anexos.imagesDocs.physicalContract1 == undefined){
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos!","ATENÇÃO")
            }            
            else
            this.e1 = 4
        },

        async avancaPasso5(){
            
              if(this.holderList.length < 5) 
              {
                var vm3 = this;
                vm3.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário inserir pelo menos 4 beneficiários!","ATENÇÃO")
              }
              else{
              //Insere valor do plano no model de empresa             
              this.empresa.valuePlanHolder = this.valorTitular
              this.empresa.valuePlanDependent = this.valorTitular
              this.empresa.responsibility = this.valorTotalProposta              
              this.$validator.reset() 
              this.precoPlano.plansId = this.planoSelecionado.id
              this.e1 = 5   
            }                 
        },

        formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },
        formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      retornoViaCEP(){
          if(/^[0-9]{5}-[0-9]{3}$/.test(this.empresa.cep)) {
          axios
          .post(`${baseApiUrl}APIS4s/EnderecoPublico`, {"cep" : this.empresa.cep})
          .then(res => {        
            if(res.data != null){     
            this.cidade = res.data.Municipio            
            this.estado = res.data.Uf
            this.empresa.state = res.data.IdUf
            this.bairro = res.data.Bairro
            this.empresa.address = res.data.Logradouro 
            this.empresa.city = res.data.IdMunicipio
            this.empresa.district = res.data.IdBairro
            this.empresa.addressType = res.data.IdTipoLogradouro
           /*  this.financialManagers.addressTypeName = res.data.TipoLogradouro */
            } 
            else{
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.empresa.Logradouro = ''
                this.cidade = ''
                this.empresa.municipio = ''
                this.estado = ''
                this.empresa.uf = ''
                this.bairro = ''
                this.empresa.bairro = ''
                this.empresa.IdTipoLogradouro = ''  
            }             	
            })
          }           
      },
      
      async consultaVendedor(){
        if(CpfValidate(this.cpfVendedor)){
         await axios
          .post(`${baseApiUrl}APIS4s/VendedoresPublico`, {"cpf" : this.cpfVendedor})
          .then(res => {
           if(res.data != ''){
             this.vendedor = res.data[0]
             this.nomeVendedor = this.vendedor.Nome
           } 
           else{
              var vmcpfvend = this;
              vmcpfvend.$refs.chamaSnackbar.snack("#F9A825","Vendedor não localizado","ATENÇÃO");
              this.vendedor.Nome = '' 
           }
          })
        }

      },     

      async enviarProposta(){
        if(!this.contrataccept)
        {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é neccesário concordar com os termos do contrato!","ATENÇÃO");
        }else
        if(this.empresa.dueDate == '')
        {
          var vmDate = this;
          vmDate.$refs.chamaSnackbar.snack("#F9A825","Informe o dia de vencimento","ATENÇÃO");
        }
        else
        {
        this.email = this.empresa.infoEmailInvoice
        this.isLoading = true

        if(this.vendedorLink != null)
        {
        this.empresa.brokerId = this.vendedorLink.brokerId
        this.empresa.salesmanId = this.vendedorLink.id
        this.empresa.plansId = this.planoSelecionado.id
        }
        else
        {
          if(this.vendedor.Id != null){
          await axios.get(`${baseApiUrl}Salesmans/infoPublico?codeS4=${this.vendedor.Id}`).then(res => {         
                  if(res.data != null){      
                      this.salesman = res.data
                      }              	
                  })     
          this.empresa.brokerId = this.salesman.brokerId
          this.empresa.salesmanId = this.salesman.id
          this.empresa.plansId = this.planoSelecionado.id
          }
          else{
          this.empresa.brokerId = this.planoSelecionado.brokerIdDefault
          this.empresa.salesmanId = this.planoSelecionado.salesmanIdDefaut 
          this.empresa.plansId = this.planoSelecionado.id
          }
        }

        //SALVAR COMPANY
        try {
          let res = await axios.post(`${baseApiUrl}Companies/salvarPublico`, this.empresa )
            if(res.data != ''){     
                this.empresaId = res.data.id
                this.salvarAnexos()
                    }              	
        } catch (error) {
              this.isLoading = false
              var vmFim = this;
              vmFim.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar Empresa, tente novamente ou contate a Orale");              
        }                                        
        }

      },  
      
      async salvarAnexos(){
        if(this.empresaId != '')
        {
        try {
          this.Anexos.id = this.empresaId
          let res = await axios.post(`${baseApiUrl}Companies/salvarDocsPublico`, this.Anexos )
          if(res.data != '')
            this.salvarPrecoplano()
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar anexos, tente novamente ou contate a Orale","ERRO");              
        }
        }
      },

      async salvarPrecoplano()
      {
        try {
          this.precoPlano.companyId = this.empresaId
          let res = await axios.post(`${baseApiUrl}Companies/salvarPrecoPlanoPublico`, this.precoPlano )
          if(res.data != '')
          {
            this.salvarBeneficiarios()
          }          
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar o valor do plano, tente novamente ou contate a Orale","ERRO");              
          
        }
      },

      async salvarBeneficiarios()
      {
        for(var i=0; i<this.holderList.length; i++) {
          var dependentes = []
            try {  
              dependentes = this.holderList[i].dependents  
              delete this.holderList[i].dependents  
              this.holderList[i].companyId = this.empresaId                   
              let res = await axios.post(`${baseApiUrl}Dependents/salvarPublico`, this.holderList[i] )
              if(res.data != '')
              {
                for(var i2=0; i2<dependentes.length; i2++) 
                {
                  dependentes[i2].companyId = this.empresaId
                  dependentes[i2].holderId = res.data.id
                  this.salvarDependente(dependentes[i2])
                }
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar titular, tente novamente ou contate a Orale","ERRO");              
            }
            if(this.holderList.length == i + 1)
              this.enviaEmaileFinaliza()
          }
      },

      async salvarDependente(dependente)
      {
        try {
          await axios.post(`${baseApiUrl}Dependents/salvarPublico`, dependente )
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar dependentes, tente novamente ou contate a Orale","ERRO");              
        }
      },

      async enviaEmaileFinaliza()
      {
        try {
          let res = await axios.post(`${baseApiUrl}Companies/enviarEmailCriacaoPublico`, {'id':this.empresaId} )
          if(res.data != ''){   
              this.isLoading = false   
              this.dialogLoading = true 
            }
          
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao enviar email de confirmação, tente novamente ou contate a Orale","ERRO");              
        }        
      },

      close() {
          this.dialogDelTitular = false
          this.dialogDelDep = false
          this.dialogTitular = false
          this.dataNascFunc = ''
          this.dataNascDependent = ''
          this.dialogDep = false       
          this.dependente = Object.assign({}, this.defaultdependente)
          this.funcionario = Object.assign({}, this.defaltfuncionario)   
          this.$validator.reset()          
          this.dialogValidacao = false
      },

      confirmaContrato(){
        this.close()
        this.$router.push({ path: '/' })
      },      
        calculateAge(dobString) {
        var dob = new Date(dobString);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if(birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      },

//CONTROLE DE ANEXOS

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },

    inputFileRg1(newFile, oldFile) {
      if (newFile && !oldFile) {       
        var reader = new FileReader();        
        var file = this.filesRg1[0]
        
        //salva a base64 na variável
        reader.onloadend = function() { 
                  
         document.getElementById("rg1").value = reader.result            
        
        };            
        //Gera base64
        reader.readAsDataURL(file.file);  
        //this.files = []     

      }
      if (newFile && oldFile) {
        // update
      }
      if (!newFile && oldFile) {
        // remove
      }
    },
    
      inputFileRg2(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesRg2[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("rg2").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

      inputFileCPF(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesCPF[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("cpf").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

    inputFileAddress(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesAddress[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("address").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

    inputFileOutros(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesOutros[0]
        //Gera base643
        reader.onloadend = function() { 

          document.getElementById("outros").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    }, 

    inputFileCNPJ(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesCNPJ[0]
        //Gera base643
        reader.onloadend = function() { 

          document.getElementById("cnpj").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },  
    
    inputFilephysicalContract1(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesphysicalCOntract1[0]
        //Gera base643
        reader.onloadend = function() { 

          document.getElementById("physicalContract1").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },    

    calculaPlano(plano){
      this.qtdUsuarios = 0
      var valorFaixa = plano.value.replace(',','.')
      this.qtdUsuarios = this.empresa.amountHolder + this.empresa.amountDependent
      
      //Trata faixa de usuários
      if(this.qtdUsuarios >= 1 && this.qtdUsuarios <= 100)
      {
      valorFaixa = plano.value.replace(',','.')
      this.precoPlano.valorTitular = plano.value.replace(',','.')
      this.precoPlano.valorDependente = plano.value.replace(',','.')
      this.precoPlano.valorAgregado = plano.value.replace(',','.')
      }      

      if(this.empresa.amountHolder  != '')
      this.valorTitular = (valorFaixa * this.empresa.amountHolder).toFixed(2)
      else
      this.valorTitular = '0.00'
      if(this.empresa.amountDependent  != '')
      this.valorDependentes = (valorFaixa * this.empresa.amountDependent).toFixed(2)
      else
      this.valorDependentes = '0.00'
      //this.valorTotalProposta = (parseFloat(this.plano.taxaImplantacao) * qtdUsuarios)
      this.valorTotalProposta = (parseFloat(plano.taxaImplantacao.replace(',','.')) * this.qtdUsuarios + parseFloat(this.valorTitular) + parseFloat(this.valorDependentes)).toFixed(2)
    },

    async pegaParametrosUrl(){
      var params = window.location.search.substring(1).split('&');
      if(params[0] != ''){
      //Criar objeto que vai conter os parametros
      var paramArray = {};

      //Passar por todos os parametros
      for(var i=0; i<params.length; i++) {
          //Dividir os parametros chave e valor
          var param = params[i].split('=');

          //Adicionar ao objeto criado antes
          paramArray[param[0]] = param[1];
          }
      if(paramArray['plano'])
      {
      sessionStorage.clear()    
      await axios.get(`${baseApiUrl}Plans/buscarPublicoPorId?id=${paramArray['plano']}`).then(res => {        
            if(res.data != null){     
            this.planoSelecionado = res.data
            //this.pdfSelecionado = this.planoSelecionado.urlMinutaContrato 
            }              	
      }) 
      }
          if(paramArray['vendedor'])
          {
          await axios.get(`${baseApiUrl}Salesmans/infoPublico?linkSite=${paramArray['vendedor']}`).then(res => {        
            if(res.data != null){
            this.vendedorLink = res.data 
            this.temVendedor = true
            this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite
            this.financialManagers.vendedor = this.vendedorLink.linkSite 
            this.financialManagers.CPFVendedor =  this.vendedorLink.cpf     
            this.financialManagers.salesmanId = this.vendedorLink.id  
            this.financialManagers.brokerId = this.vendedorLink.brokerId        
          }
          })
          }
    }
/*       if(this.planoSelecionado.area_atuacao == 'SINDILOJAS - SP')
        this.exibeCorretor = false */
    }, 
    } 

}
</script>

<style>
.v-table__overflow {
    border-radius: 10px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

span.v-stepper__step__step.primary{
    background-color: #009B99!important;
    border-color: #009b9b!important;
}

.theme--light.v-stepper .v-stepper__label {
    color: #009B99;
}
.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
}

table.v-table thead tbody tr th {
    background-color: #009b9b;
    font-size: 1rem;
    height: 0px;
  }

.v-list__tile.theme--light{
  justify-content: center;
}

.centralizar {
    text-align: left;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: none;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
}
table.v-table tbody td, table.v-table tbody th {
    height: 35px;
}
  .theme--light.v-table thead th  {
    color: white;
  }

  .theme--light.v-datatable thead th.column.sortable:hover {
    color: rgb(17, 16, 16);
  }

  .theme--light.v-datatable thead th.column.sortable.active {
    color: white;
    font-weight: bold;
  }

  table.v-table thead th:first-child, table.v-table tbody th:first-child {
    padding: 15px 24px;
  }   
  .form-titulo {
    font-size: 22px;
    font-weight: 700;
    color: #009b9b;
    margin-bottom: 20px;
  }

  hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
  .resumo p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
    color: #828585;
  }
  .subtotal {
    font-weight: 700;
    font-size: 20px;
    color: #828585;
  }
  .total {
    font-size: 30px;
    color: #009b9b;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;
  }
  .page-content p {
    margin-bottom: 0;
  }
  .cardpag{
    background-color: #009B99;
    color: white;
  /*   color: #009B99; */
    justify-content: center;
    font-weight: 700;
    font-size: 20px;
  }
  a{
    text-decoration: none
  }

  .imgpag{
    opacity: 0.5;
  }

</style>
